module.exports = __webpack_public_path__ + "static/media/Plants_R1 (1).2521de4c.png";